import apiClient from './apiClient';

// Convert '/' to '-' for URL path (e.g., BTC/USD -> BTC-USD), backend converts back
const normalizeSymbolForUrl = (symbol) => symbol?.replace('/', '-') || '';

const userTradeSignalsAPI = {
  /**
   * Get trade signals for the authenticated user
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getUserTradeSignals: (params = {}) => {
    const queryString = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryString.append(key, params[key]);
      }
    });

    const url = `/user/trade-signals${queryString.toString() ? `?${queryString.toString()}` : ''}`;
    return apiClient.get(url);
  },

  /**
   * Get active trade signals for the authenticated user
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getUserActiveTradeSignals: (params = {}) => {
    const queryString = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryString.append(key, params[key]);
      }
    });

    const url = `/user/trade-signals/active${queryString.toString() ? `?${queryString.toString()}` : ''}`;
    return apiClient.get(url);
  },

  /**
   * Get trade signal statistics for the authenticated user
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getUserTradeSignalStats: (params = {}) => {
    const queryString = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryString.append(key, params[key]);
      }
    });

    const url = `/user/trade-signals/stats${queryString.toString() ? `?${queryString.toString()}` : ''}`;
    return apiClient.get(url);
  },

  /**
   * Get recent trade signals from the last 5 days for the authenticated user
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getUserRecentTradeSignals: (params = {}) => {
    const queryString = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        // Use cursor instead of offset
        if (key === 'offset') {
          queryString.append('cursor', params[key]);
        } else {
          queryString.append(key, params[key]);
        }
      }
    });

    const url = `/user/trade-signals/recent${queryString.toString() ? `?${queryString.toString()}` : ''}`;
    return apiClient.get(url);
  },

  /**
   * Get trade signals for a specific symbol for the authenticated user
   * @param {string} symbol - Trading symbol
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getUserTradeSignalsBySymbol: (symbol, params = {}) => {
    const queryString = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryString.append(key, params[key]);
      }
    });

    const url = `/user/trade-signals/symbol/${normalizeSymbolForUrl(symbol)}${queryString.toString() ? `?${queryString.toString()}` : ''}`;
    return apiClient.get(url);
  },

  /**
   * Delete user trade signals older than a given number of weeks
   * @param {number} olderThanWeeks - Weeks threshold
   * @returns {Promise} API response
   */
  purgeUserTradeSignals: (olderThanWeeks) => {
    return apiClient.post('/user/trade-signals/purge', {
      olderThanWeeks
    });
  }
};

export default userTradeSignalsAPI;
